// interface IOptionsRobotActions {

import React, { useState, useRef, useEffect } from "react";
import WaveSurfer from "wavesurfer.js";
import { Text } from "../../../components/Text";

import { NewWaveformContainer, RoundedButton, WaveContainer } from "./styles";
import { Pause, PlayWhite } from "../../../assets";
import { ClockAudio } from "../../../components/Interactions/components/interacaoRobo/AudiosModal/ClockAudio";
import ColorSvg from "../../../components/ColorSvg";
import { useAppSelector, useAppDispatch } from "../../../redux/hooks";
import { setAudioPlaying } from "../../../redux/slices/flowInteractions";
interface IAudioPlayer {
  url: string;
  played?: boolean;
}
// audio/ogg
export const AudioPlayer: React.FC<IAudioPlayer> = ({ url, played }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const waveSurferRef = useRef<WaveSurfer>(null);
  const waveformRef = useRef(null);

  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [indexSpeed, setindexSpeed] = useState(0);
  const speeds = [1, 1.5, 2];
  const id = `#Wsf${url.slice(url.lastIndexOf("-") + 1)}`;

  const dispatch = useAppDispatch();
  const audioPlaying = useAppSelector(
    (state) => state.flowInteractions.audioPlaying
  );

  useEffect(() => {
    // if(waveSurferRef?.current) {
    if (!waveformRef.current) {
      return;
    }
    waveSurferRef.current = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: "blue",
      progressColor: "green",
      backend: "MediaElement"
    });
    waveSurferRef.current?.load(url);
    setDuration(waveSurferRef.current?.getDuration() as number);
    // eslint-disable-next-line consistent-return
    return () => {
      if (waveSurferRef.current) {
        waveSurferRef.current.destroy();
        dispatch(setAudioPlaying(null));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  useEffect(() => {
    let setIntervall: string | number | NodeJS.Timeout | undefined;

    waveSurferRef?.current?.on("ready", () => {
      setDuration(waveSurferRef?.current?.getDuration() as number);
      setCurrentTime(0);
    });
    waveSurferRef?.current?.on("play", () => {
      setIsPlaying(true);
      setIntervall = setInterval(() => {
        setCurrentTime(waveSurferRef?.current?.getCurrentTime() as number);
      }, 1000);
      setDuration(waveSurferRef?.current?.getDuration() as number);
    });
    waveSurferRef?.current?.on("finish", () => {
      setIsPlaying(false);
      waveSurferRef?.current?.setCurrentTime(0);
      setCurrentTime(0);
      setDuration(waveSurferRef?.current?.getDuration() as number);
      clearInterval(setIntervall);
    });
    waveSurferRef?.current?.on("pause", () => {
      setCurrentTime(waveSurferRef?.current?.getCurrentTime() as number);
      setIsPlaying(false);
      clearInterval(setIntervall);
    });
    // }
    if (isPlaying === false) {
      clearInterval(setIntervall);
    }
    return clearInterval(setIntervall);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaying, currentTime, duration]);

  const togglePlay = () => {
    if (isPlaying) {
      waveSurferRef?.current?.pause();
      setIsPlaying(false);
    } else {
      if (audioPlaying && audioPlaying !== waveSurferRef.current) {
        audioPlaying?.pause();
        dispatch(setAudioPlaying(null));
      }
      waveSurferRef?.current?.on("ready", () => {
        setDuration(waveSurferRef?.current?.getDuration() as number);
        setCurrentTime(0);
      });
      dispatch(setAudioPlaying(waveSurferRef.current));
      waveSurferRef?.current?.play();
      setIsPlaying(true);
    }
  };

  const changeSpeed = () => {
    if (indexSpeed === 2) {
      setindexSpeed(0);
    } else {
      setindexSpeed(indexSpeed + 1);
    }
    waveSurferRef?.current?.setPlaybackRate(speeds[indexSpeed + 1]);
  };

  return (
    <NewWaveformContainer>
      <ClockAudio
        isPlaying={isPlaying}
        timeTotal={duration}
        timeCurrent={currentTime}
      />
      <WaveContainer>
        <div id={id} ref={waveformRef}></div>
      </WaveContainer>
      <RoundedButton onClick={changeSpeed}>
        <Text s="0.7rem">{speeds[indexSpeed]}x</Text>
      </RoundedButton>
      <RoundedButton onClick={togglePlay}>
        {isPlaying ? (
          <img src={Pause} alt="Pause audio" />
        ) : played ? (
          <ColorSvg src={PlayWhite} color="#7B89A3" size={7} />
        ) : (
          <img src={PlayWhite} alt="Play audio" />
        )}
      </RoundedButton>
    </NewWaveformContainer>
  );
};
